module.exports = __webpack_public_path__ + "static/media/guia-do-usuario.3c689a38.pdf";